<template>
  <div>
    
    <div class="bar_nav">
      <div class="title">新建相册</div>
      <div class="bar_back_btn" @click="goToGroupHome">返回</div>
    </div>
    <div class="bar_empty"></div>

    <div class="form">
      <input class="field" label="名称" placeholder="请输入相册名称" type="text" v-model.trim="name" />
      <div class="btn_large" @click="createAlbum">保存</div>
    </div>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'CreateAlbum',
  data: function () {
    return {
      name: '',
      coverpage: ''
    }
  },
  async created () {
    
  },
  methods: {
    async createAlbum() {
      try {
        if (!this.name) {
          return Toast({
            message: '请输入相册名称'
          })
        }
        const album = await this.$faApi.createAlbum(this.$route.params.groupId, {
          name: this.name,
          coverpage: this.coverpage
        })
        this.$router.push({ path: `/group/${this.$route.params.groupId}` })
      } catch (err) {
        this.$faLogger.error('GroupHome.vue:created', err)
      }
    },
    goToGroupHome() {
      this.$router.push({ path: `/group/${this.$route.params.groupId}` })
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    margin: 0 20px;
    .set_coverpage {
      width: 100%;
      height: 80px;
      position: relative;
      text-align: center;
      background-color: antiquewhite;
      margin-bottom: 20px;
      .file_input {
        opacity: 0;
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
      }
      button {
        position: relative;
        bottom: -30px;
      }
    }
  }
</style>
  